<template>
  <div class="home">
    <h1>Welcome to Pair Dashboard</h1>
    <p v-if="user">👋 Hello, {{ user.full_name || user.username }}</p>
    <p v-else>Loading user...</p>
  </div>
</template>

<script>
import { getTelegramUser } from "@/utils/telegram";

export default {
  data() {
    return {
      user: null,
    };
  },
  mounted() {
    const tgUser = getTelegramUser();
    this.user = tgUser;

    if (tgUser) {
      fetch("/api/user/register", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(tgUser),
      })
        .then((r) => r.json())
        .then((res) => {
          console.log("✅ Registered:", res);
        });
    } else {
      console.warn("⚠️ No Telegram user found");
    }
  },
};
</script>

<style scoped>
.home {
  max-width: 500px;
  margin: 0 auto;
  padding: 2em;
}
</style>
